import React, { FC } from 'react'
import { ShipperStrikePrices } from 'apps/marketplace/apiTypes/shipperStrikePrices'
import { Table, TableBody } from 'transfix-ui'
import { StrikePriceTableHeader } from './StrikePriceTableHeader'
import { StrikePriceTableRow } from './StrikePriceTableRow'

interface IStrikePriceTableProps {
  shipperStrikePrices: ShipperStrikePrices[]
  addOrEditOverride: (price: ShipperStrikePrices) => void
  deleteOverride: (price: ShipperStrikePrices) => void
}

export const StrikePriceTable: FC<IStrikePriceTableProps> = ({
  shipperStrikePrices = [],
  addOrEditOverride,
  deleteOverride,
}) => {
  return (
    <Table dataTest='strike-price-table'>
      <StrikePriceTableHeader />
      <TableBody>
        {shipperStrikePrices.map(price => (
          <StrikePriceTableRow
            key={price.id}
            shipperStrikePrice={price}
            addOrEditOverride={addOrEditOverride}
            deleteOverride={deleteOverride}
          />
        ))}
      </TableBody>
    </Table>
  )
}
